import {
  LOGIN_MESSAGE,
  RESET,
  RESET_USER_CONTRACTS_TRIALS,
  SET_CONTRACT_PREFERENCES,
  SET_USER,
  SET_USER_CONTRACTS,
  SET_USER_CONTRACTS_LOADING,
  SET_USER_CONTRACTS_TRIALS,
  SET_USER_CONTRACTS_TRIALS_LOADING,
  SET_USER_SIDEBAR_COLLAPSE,
  SET_USER_TRIALS,
  SET_USER_TRIALS_LOADING,
} from "./actionTypes";
import { addDangerAlert, addSuccessAlert } from "./alerts";
import {
  requestFetchUser,
  requestFetchUserContracts,
  requestFetchUserTrials,
  sendMail,
} from "../services/backendRequests";

import _ from "lodash";

/**
 * Log user into API
 */
export function login(email, password) {
  return (dispatch) => {
    dispatch({
      type: LOGIN_MESSAGE,
      loginMessage: "",
    });

    return fetch("/api/users/sign_in", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        password,
      }),
    }).then((response) => {
      const identity = {
        "access-token": response.headers.get("access-token"),
        client: response.headers.get("client"),
        expiry: response.headers.get("expiry"),
        "token-type": response.headers.get("token-type"),
        uid: response.headers.get("uid"),
      };

      response.json().then((userData) => {
        const user = userData.data;

        if (response.status === 200) {
          // Set user and identity
          dispatch({
            type: SET_USER,
            identity,
            user,
          });

          dispatch(fetchUserContracts());
        } else {
          dispatch({
            type: LOGIN_MESSAGE,
            loginMessage: "Email or password are incorrect.",
          });
        }
      });
    });
  };
}

export function refreshUser() {
  return (dispatch, getState) => {
    const { user } = getState();

    if (_.isEmpty(user.self)) return;

    requestFetchUser(user.self.id, user)
      .then((userData) => {
        dispatch({
          type: SET_USER,
          identity: user.identity,
          user: userData,
        });

        dispatch(fetchUserContracts());
      })
      .catch((err) => {
        dispatch({
          type: RESET,
        });
        dispatch({
          type: LOGIN_MESSAGE,
          loginMessage: err,
        });
      });
  };
}

/**
 * Remove user object from store on logout
 */
export function logout() {
  return (dispatch, getState) => {
    return fetch("/api/users/sign_out", {
      method: "DELETE",
      headers: getState().user.identity,
    }).then(
      dispatch({
        type: RESET,
      })
    );
  };
}

function setUserContracts(contracts) {
  return {
    type: SET_USER_CONTRACTS,
    contracts,
  };
}

function setUserTrials(trials) {
  return {
    type: SET_USER_TRIALS,
    trials,
  };
}

function setUserContractsTrials(contracts, trials) {
  return {
    type: SET_USER_CONTRACTS_TRIALS,
    contracts,
    trials,
  };
}

function setUserContractsLoading() {
  return {
    type: SET_USER_CONTRACTS_LOADING,
  };
}

function setUserTrialsLoading() {
  return {
    type: SET_USER_TRIALS_LOADING,
  };
}

function setUserContractsTrialsLoading() {
  return {
    type: SET_USER_CONTRACTS_TRIALS_LOADING,
  };
}

export function fetchUserContracts() {
  return (dispatch, getState) => {
    dispatch(setUserContractsLoading());
    requestFetchUserContracts(getState().user)
      .then((contracts) => {
        dispatch(setUserContracts(contracts));
      })
      .catch((err) => dispatch(addDangerAlert(err)));
  };
}

export function fetchUserTrials() {
  return (dispatch, getState) => {
    dispatch(setUserTrialsLoading());
    requestFetchUserTrials(getState().user)
      .then((trials) => {
        dispatch(setUserTrials(trials));
      })
      .catch((err) => dispatch(addDangerAlert(err)));
  };
}

export function setContractPreferences(contractId, preferences) {
  return {
    type: SET_CONTRACT_PREFERENCES,
    contractId,
    preferences,
  };
}

export function fetchUserContractsTrials() {
  return (dispatch, getState) => {
    dispatch(setUserContractsTrialsLoading());
    Promise.all([
      requestFetchUserContracts(getState().user),
      requestFetchUserTrials(getState().user),
    ])
      .then(([contracts, trials]) => {
        dispatch(setUserContractsTrials(contracts, trials));
      })
      .catch((err) => dispatch(addDangerAlert(err)));
  };
}

/**
 * Remove user object from store on logout
 */
export function resetUserContractsTrials() {
  return (dispatch) => {
    dispatch({
      type: RESET_USER_CONTRACTS_TRIALS,
    });
  };
}

export function sendContactMail(mailContent) {
  return (dispatch, getState) =>
    sendMail(mailContent, getState().user)
      .then(() =>
        dispatch(
          addSuccessAlert(
            "Mail sent. We will come back to you as soon as possible."
          )
        )
      )
      .catch((err) => {
        dispatch(addDangerAlert(err));
        throw err; // propage pour que l'appelant distingue succès / échec
      });
}

export function setSidebarCollapse() {
  return (dispatch) => {
    dispatch({
      type: SET_USER_SIDEBAR_COLLAPSE,
    });
  };
}
